export enum WeightChangeMeasures {
  MEASURES_CHECKED = 'MEASURES_CHECKED',
  MEASURES_STARTED = 'MEASURES_STARTED',
}
